import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';

type NkSimpleButtonProps = {
  name: string;
  variant?: 'contained' | 'outlined' | 'text';
  color?: 'default' | 'inherit' | 'primary' | 'secondary';
  size?: 'small' | 'medium' | 'large';
  onClick?: () => void;
  isDisabled?: boolean;
  isRequesting?: boolean;
  label?: string;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
};

const NkSimpleButton = (props: NkSimpleButtonProps) => {
  return (
    <Button
      {...props}
      name={props.name}
      variant={props.variant}
      color={props.color}
      size={props.size || 'medium'}
      onClick={props.onClick}
      disabled={props.isRequesting || props.isDisabled}
      startIcon={props.startIcon}
      endIcon={props.endIcon}
    >
      {props.label}
    </Button>
  );
};
NkSimpleButton.muiName = 'Button';

NkSimpleButton.propTypes = {
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  isRequesting: PropTypes.bool,
  variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  style: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
};

export default NkSimpleButton;
